export const ID67 = () => {
    return (
        <div className="section__tab" id="obshchaya_kharakteristika_programmy">
            <div className="about-card__title">
                Общая характеристика программы:
            </div>
            <p>
                Прикладное решение «1С-Рейтинг: Нефтебаза» предназначено для автоматизации деятельности предприятий,
                занимающихся оптовой и розничной торговлей нефтепродуктами.
            </p>
            <p>
                Прикладное решение построено на основе типовой конфигурации «Бухгалтерия для Казахстана», что позволяет
                вести в одной информационной базе бухгалтерский, налоговый и оперативный учет финансово-хозяйственной
                деятельности предприятия.
            </p>
            <p>
                В рамках данного материала рассматривается оперативный, бухгалтерский и налоговый учет нефтепродуктов.
                Формирование СНТ и ЭСФ, движений нефтепродуктов на Виртуальном складе формами ЭДВС с последующей
                отправкой в ИС ЭСФ проводятся типовыми механизмами решения «Бухгалтерия для Казахстана».
            </p>
            <p>
                Программный продукт позволяет автоматизировать различные схемы оптово-розничной реализации
                нефтепродуктов, в том числе:
            </p>
            <ul>
                <li>реализация нефтепродуктов с нефтебаз;</li>
                <li>розничная реализация с автозаправочных станций;</li>
                <li>ответственное хранение;</li>
                <li>учет талонов и отпуска горюче-смазочных материалов по ним.</li>
            </ul>
            <p>
                Основные возможности конфигурации:
            </p>
            <ul>
                <li>учет движения горюче-смазочных материалов в разрезе пин-кодов;</li>
                <li>ведение учета горюче-смазочных материалов в единицах объема или массы;</li>
                <li>гибкая система пересчета по объемно-массовым показателям;</li>
                <li>учет реализации горюче-смазочных материалов по талонам в литрах;</li>
                <li>пересчет из учетных единиц измерения ТМЗ в единицы измерения налоговой базы акциза;</li>
                <li>реализация горюче-смазочных материалов в различных единицах измерения;</li>
                <li>учет горюче-смазочных материалов, находящихся на ответственном хранении;</li>
                <li>формирование печатных форм первичных документов в мере массы и мере объема (в том числе
                    счетов-фактур);
                </li>
                <li>интеграция с ИС ЭСФ (СНТ, ЭСФ, ведение учета на ВС);</li>
                <li>формирование деклараций по оптовой и розничной реализации нефтепродуктов.</li>
            </ul>
            <p>
                Конфигурация состоит из трёх подсистем:
            </p>
            <ul>
                <li>управления запасами нефтепродуктов;</li>
                <li>ответственного хранения нефтепродуктов;</li>
                <li>учета талонов.</li>
            </ul>
            <p>
                Подсистема управления запасами нефтепродуктов позволяет автоматизировать учет движения стоимости
                горюче-смазочных материалов в разрезе пин-кодов. Подсистема позволяет оформлять операции:
            </p>

            <ul>
                <li>поступления:</li>
                <ul>
                    <li>покупка;</li>
                    <li>учет дополнительных расходов;</li>
                    <li>импорт;</li>
                    <li>возврат поставщику.</li>
                </ul>
                <li>реализации:</li>
                <ul>
                    <li>счета на оплату;</li>
                    <li>продажа оптом;</li>
                    <li>продажа через АЗС;</li>
                    <li>возвраты от покупателей.</li>
                </ul>
                <li>складского учета нефтепродуктов:</li>
                <ul>
                    <li>перемещение;</li>
                    <li>инвентаризация;</li>
                    <li>оприходование;</li>
                    <li>списание.</li>
                </ul>
            </ul>
            <p>
                Предусмотрена возможность ввода начальных остатков горюче-смазочных материалов, в том числе без
                отражения на счетах бухгалтерского учета.
            </p>
            <p>Складской учет горюче-смазочных материалов, находящихся на ответственном хранении, ведется с
                использованием документов подсистемы «Ответственное хранение нефтепродуктов». При этом возможны
                следующие схемы ответственного хранения нефтепродуктов:</p>
            <ul>
                <li>горюче-смазочные материалы реализованы покупателю, но по каким-либо причинам, не могут быть сразу
                    вывезены с нефтебазы;
                </li>
                <li>предприятие оказывает платные услуги ответственного хранения горюче-смазочных материалов в качестве
                    дополнительного вида деятельности.
                </li>
            </ul>
            <p>
                Подсистема учета талонов предоставляет возможность вести поштучный учет оборота талонов от момента
                реализации покупателю вплоть до погашения или возврата, а также учитывать объем реализованных по талонам
                горюче-смазочных материалов в количественно-суммовом выражении.
            </p>
            <p>
                По накопленным в конфигурации данным предусмотрено формирование специализированной отчетности,
                позволяющей всесторонне проанализировать результаты финансово-хозяйственной деятельности по обороту
                нефтепродуктов.
            </p>
            <p>
                В составе конфигурации поставляется набор регламентированной отчетности, включающий декларации по
                оптовой и розничной реализации нефтепродуктов с возможностью выгрузки в формате XML в клиентское
                приложение для декларантов НК МФ РК.
            </p>
        </div>
    )
}